import { HisInformationItem, HisInformationItemSet } from "../../his";
import { EditPhaseKinds } from "../../document";

// WF文書・依頼書HIS項目用Model
export class WorkflowHisInformation {
  // HIS項目
  public items: HisInformationItem[];
  // 証明期間（入院）HIS項目
  public hospitalizationItems: HisInformationItem[];
  // 証明期間（外来）HIS項目
  public diseaseItems: HisInformationItem[];
  // 現在の差し込みタイミング
  public editPhaseTypes: EditPhaseKinds[];
  // 対応責任者
  public managerUserCodes: string[];
  // 証明期間（入院）のHIS項目一覧（進捗・タイミングに依存しない）
  public hospitalizationItemSets: HisInformationItemSet[];
  // 確定登録のタイミングかどうか
  public isCommitPhase: boolean;
}
